// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"ee709b40","296":"5c856840","538":"62aa2597","667":"1dd3725f","687":"1dd3725f"}[chunkId] + ".chunk.css";
};